import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Cursos } from 'generated/graphql';

interface SelectedEstudianteI {
	key: string;
	nombre: string;
	grupo: string;
	apellido?: string;
	grupoKey?: string;
	curso?: Cursos;
}

const initialState: SelectedEstudianteI = null as any;

const selectedEstudianteStateSlice = createSlice({
	name: 'selectedEstudianteState',
	initialState,
	reducers: {
		setSelectedEstudianteState: (state, action: PayloadAction<SelectedEstudianteI>) => {
			return action.payload;
		},
		resetSelectedEstudianteState: () => {
			return initialState;
		}
	}
});

export const { setSelectedEstudianteState, resetSelectedEstudianteState } = selectedEstudianteStateSlice.actions;

export default selectedEstudianteStateSlice.reducer;
